import { useEffect, useState } from 'react';
import type { ProbeResult } from './platform/diagnostics';

/**
 * The dev flavour's transport diagnostics (ADR-029 §7, `/?diag=1` inside a shell): runs the
 * IdP-free probes once and lists each outcome as `PASS` / `FAIL` — the strings the Maestro
 * flow asserts on the emulator.
 */
export function Diagnostics({ run }: { run: () => Promise<ProbeResult[]> }) {
  const [results, setResults] = useState<readonly ProbeResult[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    run().then((outcome) => {
      if (!cancelled) setResults(outcome);
    });
    return () => {
      cancelled = true;
    };
  }, [run]);

  return (
    <section className="card diagnostics" aria-label="diagnostics">
      <div className="page-heading">
        <div>
          <p className="eyebrow">Connection check</p>
          <h2>Transport diagnostics</h2>
        </div>
      </div>
      {results === null ? (
        <p className="notice" role="status">Running…</p>
      ) : (
        <ul className="diagnostics-results">
          {results.map((result) => (
            // One text node per line: an accessibility tree (the Maestro flow on a WebView) then
            // sees "PASS <name> — <detail>" as a single element.
            <li key={result.name} data-outcome={result.ok ? 'pass' : 'fail'}>
              {`${result.ok ? 'PASS' : 'FAIL'} ${result.name} — ${result.detail}`}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
